// DS: DEV7
import React from 'react';
import PopoverCard from '../_partials/PopoverCard';
import DialogCardLayout from '../_partials/DialogCardLayout';
var PopoverDialog = function (_a) {
    var title = _a.title, className = _a.className, withScrollableContentWrapper = _a.withScrollableContentWrapper, children = _a.children, footer = _a.footer, footerExtras = _a.footerExtras, headerExtras = _a.headerExtras, onClose = _a.onClose;
    return (React.createElement(PopoverCard, { className: className, onClose: onClose },
        React.createElement(DialogCardLayout, { isConcise: true, title: title, headerExtras: headerExtras, footer: footer, footerExtras: footerExtras, withScrollableContentWrapper: withScrollableContentWrapper }, children)));
};
PopoverDialog.displayName = 'PopoverDialog';
export default PopoverDialog;
//# sourceMappingURL=PopoverDialog.js.map